import { render, staticRenderFns } from "./usTermsPopup.vue?vue&type=template&id=2d3469fd&"
import script from "./usTermsPopup.vue?vue&type=script&lang=js&"
export * from "./usTermsPopup.vue?vue&type=script&lang=js&"
import style0 from "./usTermsPopup.vue?vue&type=style&index=0&id=2d3469fd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports